<template>
    <header>
      <nav>
        <ul>
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/about">Experiments</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </nav>
    </header>
  </template>
  
  <script>
  export default {
    name: 'HeaderComponent',
  };
  </script>
  
  <style scoped>
header {
  background-color: #000000;
  padding: 10px 0;
  clip-path: polygon(0% 0%, 100% 0%, 80% 100%, 20% 100%);
  position: relative;
  box-shadow: inset 0 0 0 2px #FF9442; 
  color:"FF9442";
}


@media (max-width: 768px) {
  header {
    clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);
  }
}
  
  nav ul {
    list-style-type: none;
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0;
    color: #FF9442;
  }
  
  nav ul li {
    margin: 0 15px;
  }
  
  nav ul li a {
    color: #FF9442;
    text-decoration: none;
    font-weight: bold;
  }
  </style>